module.exports = __webpack_public_path__ + "static/unbinding-the-heart-ed27694b58cd5fb9473ced17d011bd9d.jpg";